var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "swiper",
    {
      ref: "swiper",
      staticClass: "swiper",
      attrs: { options: _vm.swiperOptions },
    },
    [
      _c("swiper-slide", { staticClass: "swiper-slide swiper-slide--end" }),
      _vm._v(" "),
      _vm._l(_vm.images, function (item, index) {
        return _c("swiper-slide", { key: index, staticClass: "mx-2.75" }, [
          _c("picture", [
            _c("source", {
              attrs: { type: "image/webp", srcSet: item.image[0].webp },
            }),
            _vm._v(" "),
            _c("img", {
              attrs: {
                src: item.image[0].url,
                alt: item.image[0].title,
                loading: "lazy",
                width: "960",
                height: "1290",
              },
            }),
          ]),
        ])
      }),
      _vm._v(" "),
      _c("swiper-slide", { staticClass: "swiper-slide swiper-slide--end" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }